import { createFileRoute } from "@tanstack/react-router"
import { Crumb } from "modules/shared/lib/breadcrumbs"

import "modules/support/lang"

export const Route = createFileRoute("/_base/_auth/support")({
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("support.header.title"),
    })
  },
})
